import React from "react";
import styles from "./WizardFooter.module.scss";
import classNames from "classnames";
import useBodyClass from "../Widgets/useBodyClass";

const WizardFooter = ({children, className, style}) => {
    useBodyClass(styles.active);

    return <footer className={classNames(styles.base, className)} style={style}>
        {children}
    </footer>
}

export default WizardFooter;
